var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "green-operation__status" },
    [
      _vm.canViewHistoricalRecords
        ? _c("div", { staticClass: "green-operation__status-actions" }, [
            _c(
              "a",
              {
                staticClass: "green-operation__history-link",
                on: {
                  click: function ($event) {
                    return _vm.$emit("view-historical-records")
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("tenancy.greenOperation.viewHistoricalHistory")
                    ) +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "green-operation__status-info row align-center" },
        [
          _c("div", { staticClass: "small-12 row" }, [
            _c(
              "div",
              { staticClass: "small-6" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("tenancy.greenOperation.reviewStatus"))),
                ]),
                _vm._v(" "),
                !_vm.isStarted
                  ? _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.currentStatus) +
                          "\n        "
                      ),
                    ])
                  : _c("HKLStatusBadge", {
                      staticClass: "green-operation__status-value pointer",
                      attrs: { value: _vm._f("uppercase")(_vm.currentStatus) },
                      on: { click: _vm.openLifecycle },
                    }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "small-6" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("tenancy.greenOperation.expiryDate"))),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n          " + _vm._s(_vm.expiryDateDisplay) + "\n        "
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.isStarted && _vm.isTenant
        ? _c("HKLGrayHint", { staticClass: "tenant-hint font-size-14" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("tenancy.greenOperation.sustainabilityHint")) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("GreenOperationStatusLifecycle", { ref: "modal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }